import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-closeIcon",
  "use": "icon-closeIcon-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-closeIcon\">\n<g id=\"icon-closeIcon_&#229;&#133;&#179;&#233;&#151;&#173;\">\n<path id=\"icon-closeIcon_Vector 351\" d=\"M4.5 4.5L13.5 13.5\" stroke=\"#333333\" stroke-width=\"2\" stroke-linecap=\"round\" />\n<path id=\"icon-closeIcon_Vector 352\" d=\"M13.5 4.5L4.5 13.5\" stroke=\"#333333\" stroke-width=\"2\" stroke-linecap=\"round\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol